/** Browser in-memory cache for month availability (calendar browsing). */
export const BOOKING_AVAILABILITY_CLIENT_CACHE_MS = 3 * 60 * 1000;

/** Min interval between hover prefetches (same month query). */
export const BOOKING_AVAILABILITY_PREFETCH_MIN_MS = 60 * 1000;

/** Next.js Data Cache TTL for GHL month free-slots (server). */
export const GHL_AVAILABILITY_REVALIDATE_SECONDS = 120;

/** HTTP cache for `/api/booking/availability` responses (browser). */
export const BOOKING_AVAILABILITY_HTTP_MAX_AGE_SECONDS = 120;
